(function () {
  if (window.__pvOtpBound) return;
  window.__pvOtpBound = true;

  var inflight = false;

  function pvOtpHydratePrices(root) {
    var container = root && root.querySelectorAll ? root : document;
    var hits = container.querySelectorAll('[data-pv-otp][data-pv-otp-price]');
    for (var i = 0; i < hits.length; i++) {
      pvOtpHydrateOne(hits[i]);
    }
  }

  function pvOtpHydrateOne(hit) {
    var price = hit.getAttribute('data-pv-otp-price');
    if (!price) return;
    var rte = hit.querySelector('.pv-otp-block__rte');
    if (!rte) return;
    var markup = '<span class="pv-otp-block__price">' + price + '</span>';
    var html = rte.innerHTML;
    var next = html
      .replace(/\{\{\s*price\s*\}\}/gi, markup)
      .replace(/\[\[\s*price\s*\]\]/gi, markup)
      .replace(/[\u007B\uFF5B]\s*price\s*[\u007D\uFF5D]/gi, markup);
    if (next !== html) rte.innerHTML = next;
  }

  function qsDrawer(root) {
    return (
      (root || document).querySelector('cart-drawer#mini-cart') ||
      (root || document).querySelector('cart-drawer[section="mini-cart"]')
    );
  }

  function getMiniCartSectionId() {
    var drawer = qsDrawer(document);
    return (drawer && drawer.getAttribute('section')) || 'mini-cart';
  }

  function normalizeMiniCartSections(sections) {
    if (!sections || sections['mini-cart']) return sections;
    var keys = Object.keys(sections);
    if (keys.length !== 1) return sections;
    var normalized = {};
    normalized['mini-cart'] = sections[keys[0]];
    return normalized;
  }

  function buildCartPayload(cart, sections) {
    var payload = Object.assign({}, cart);
    if (sections) payload.sections = normalizeMiniCartSections(sections);
    return payload;
  }

  function fetchCartState() {
    return fetch('/cart.json', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function notifyCartUpdated(cart, sections, openMiniCart) {
    var detail = { cart: buildCartPayload(cart, sections) };
    if (openMiniCart) detail.openMiniCart = true;
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: detail }));
  }

  function openMiniCartDrawer() {
    var drawer = qsDrawer(document);
    if (!drawer) return;
    try {
      drawer.open = true;
    } catch (e) {}
    drawer.setAttribute('open', '');
  }

  function openMiniCartHard(cart, sections) {
    if (cart) notifyCartUpdated(cart, sections, true);
    openMiniCartDrawer();
  }

  function getVariantIdsFromTrigger(trigger) {
    var idsJson = trigger.getAttribute('data-pv-otp-variant-ids');
    if (idsJson) {
      try {
        var parsed = JSON.parse(idsJson);
        if (Array.isArray(parsed) && parsed.length) {
          return parsed.map(function (id) {
            return String(id);
          });
        }
      } catch (err) {
        /* fall through */
      }
    }
    return [];
  }

  function addVariantsFromTrigger(trigger) {
    if (!trigger || trigger.getAttribute('aria-disabled') === 'true' || inflight) return;

    var variantIds = getVariantIdsFromTrigger(trigger);
    if (!variantIds.length) return;

    var items = variantIds.map(function (id) {
      return { id: Number(id), quantity: 1 };
    });

    trigger.setAttribute('aria-disabled', 'true');
    inflight = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: getMiniCartSectionId(),
        sections_url: window.location.pathname
      }),
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw body;
          return body;
        });
      })
      .then(function (addBody) {
        return fetchCartState().then(function (cart) {
          openMiniCartHard(cart, addBody.sections);
        });
      })
      .catch(function (err) {
        console.error('[PV OTP ATC ERROR]', err);
      })
      .finally(function () {
        inflight = false;
        trigger.removeAttribute('aria-disabled');
      });
  }

  pvOtpHydratePrices(document);
  document.addEventListener('DOMContentLoaded', function () {
    pvOtpHydratePrices(document);
  });
  document.addEventListener('shopify:section:load', function (ev) {
    if (ev && ev.target) pvOtpHydratePrices(ev.target);
  });

  document.body.addEventListener('click', function (e) {
    var hit = e.target.closest('[data-pv-otp]');
    if (!hit) return;
    if (e.target.closest('a')) return;
    e.preventDefault();
    addVariantsFromTrigger(hit);
  });

  document.body.addEventListener('keydown', function (e) {
    if (e.code !== 'Enter' && e.code !== 'Space') return;
    var hit = e.target.closest('[data-pv-otp]');
    if (!hit || hit !== document.activeElement) return;
    e.preventDefault();
    addVariantsFromTrigger(hit);
  });
})();
